import React from "react";

/** Shown at the bottom of every in-app route (dashboard + settings). */
export default function AppFooter() {
  return (
    <footer className="age-app-footer" role="contentinfo">
      <p className="age-app-footer__text">
        AgeShield — age verification for your Shopify store.
      </p>
    </footer>
  );
}
